<div class="play-wrapper">
  @if (play.producto_penya_id) {
    @if (imagen) {
      <div class="fondo imagen" (click)="detailPlay(play)">
        <img class="filtro" src="/assets/images/icons/penya.svg" alt="Imagen Peña">
      </div>
    }
    @if (!imagen) {
      <div class="imagen" (click)="detailPlay(play)">
        <img src="{{play.producto.penya.imagen}}" alt="Imagen Peña">
      </div>
    }
    <div class="play-details" (click)="detailPlay(play)">
      <div class="play-info">
        <span class="play-game-name">Participación</span>
        <span class="play-game-price">{{play.importe}}€</span>
      </div>
      <div class="play-bet" (click)="detailPlay(play)">
        <span style="font-weight: 600;">{{play.producto.penya.nombre}}</span>
      </div>
    </div>
    @if (play.state == 3) {
      <img class="image-status" src="/assets/images/icons/plays-list/prize_icon.svg">
    }
    <img (click)="openOptions()" class="play-game-details" src="/assets/images/icons/play-detail/play-details.svg">
  } @else {
    @if (imagen) {
      <div class="fondo imagen" (click)="detailPlay(play)">
        <img class="filtro" src="/assets/images/icons/penya.svg" alt="Imagen Peña">
      </div>
    }
    @if (!imagen) {
      <div class="imagen" (click)="detailPlay(play)">
        <img src="{{play.participacion.imagen}}" alt="Imagen Peña">
      </div>
    }
    <div class="play-details" (click)="detailPlay(play)">
      <div class="play-info">
        <span class="play-game-name">Participación</span>
        <span class="play-game-price">{{play.importe}}€</span>
      </div>
      <div class="play-bet" (click)="detailPlay(play)">
        <span style="font-weight: 600;">{{play.participacion.empresa.nombre}}</span>
      </div>
    </div>
    @if (play.state == 3) {
      <img class="image-status" src="/assets/images/icons/plays-list/prize_icon.svg">
    }
  }
</div>
@if (selected) {
  <div class="actions-play">
    @if (!play.abono) {
      <div class="group-action" (click)="openAbono()" >
        <img src="/assets/images/icons/play-detail/abono-play.svg">
        <span class="action-name">Suscribirse</span>
      </div>
    }
    @if (play.abono) {
      <div class="group-action" (click)="desabono()">
        <img src="/assets/images/icons/play-detail/abono-play-full.svg">
        <span class="action-name">Desuscribirse</span>
      </div>
    }
    <div class="group-action" (click)='repeat()'>
      <img src="/assets/images/icons/play-detail/repeat-play.svg">
      <span class="action-name">Repetir</span>
    </div>
  </div>
}